<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import BaseButton from '@/components/base/BaseButton.vue'
import BalanceCurrencyImage from '@/assets/images/balance-currency.png'
import { useWalletConnect } from '@/composables/game/wallet-connect'
import { formatNumberFullTruncate } from '@/helpers/utils'
import { useFortuneWheel } from '@/composables/game/fortune-wheel'
import { ref } from 'vue'
import api from '@/services/api'
import { syncPlayer } from '@/composables/game/player'
import WithdrawInfo from '@/components/WithdrawInfo.vue'

defineProps<{
  show: boolean
}>()
const emit = defineEmits<{
  (e: 'hide'): void,
  (e: 'afterConfirm'): void

}>()

const { userFriendlyAddress, rawAddress } = useWalletConnect()
const { currentBalance, updateState } = useFortuneWheel()
const isLoading = ref<boolean>(false)

async function onConfirm() {
  isLoading.value = true
  try {
    await api.usdtCashout({ walletAddress: rawAddress.value })
    isLoading.value = false
    await syncPlayer()
    await updateState()
    emit('hide')
    emit('afterConfirm')
  } catch (e) {
    isLoading.value = false
    console.error(e)
  }
}

</script>
<template>
  <TheBottomSheet
    :show="show && !!userFriendlyAddress.length"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center">
      <div class="flex flex-col items-center gap-y-6 mb-8">
        <div class="w-[120px] h-[120px] flex justify-center">
          <img
            :src="BalanceCurrencyImage"
            class="w-full object-contain"
          >
        </div>
        <div class="flex flex-col items-center">
          <h2 class="uppercase font-bold text-2xl -tracking-[0.48px] text-light-white">
            <T
              key-name="balance.withdraw.title"
              default-value="Withdrawal"
            />
          </h2>
          <p class="font-medium text-base text-center text-white/60 max-w-[315px]">
            <T
              key-name="balance.withdraw.description"
              default-value="You are about to withdraw your USDT."
            />
          </p>
        </div>
        <div class=" flex items-center justify-center gap-x-2 font-semibold text-2xl">
          <span class="text-green-primary">{{ formatNumberFullTruncate(currentBalance, true) }}</span>
          <span class="text-white">USDT</span>
        </div>
        <WithdrawInfo :wallett-address="userFriendlyAddress" />
      </div>
      <BaseButton
        class="w-full mb-3"
        :loading="isLoading"
        @click="onConfirm"
      >
        <T
          key-name="balance.withdraw.confirm"
          default-value="Confirm"
        />
      </BaseButton>
      <BaseButton
        style-type="tertiary"
        class="w-full"
        @click="$emit('hide')"
      >
        <T
          key-name="general.cancel"
          default-value="Cancel"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>